import { BUTTON_TYPES } from '@savgroup-front-common/constants';
import { MessageType } from '@savgroup-front-common/types';

import {
  $BulkActionButton,
  $BulkActionContainer,
  $BulkActionCounter,
} from './BulkAction.styles';

export interface BulkActionProps {
  count: number;
  deselectAll?: () => void;
  buttonMessage: MessageType;
  onClick: () => void;
  isLoading?: boolean;
  selectedLabel?: string;
}

const BulkAction = ({
  count,
  deselectAll,
  buttonMessage,
  onClick,
  isLoading,
  selectedLabel,
}: BulkActionProps) => {
  const counterText = selectedLabel ?? `${count} dossier(s) sélectionné(s)`;

  return (
    <$BulkActionContainer>
      <$BulkActionCounter>
        <span>{counterText}</span>
        {deselectAll && (
          <button
            type="button"
            onClick={deselectAll}
            style={{
              background: 'none',
              border: 'none',
              color: 'inherit',
              textDecoration: 'underline',
              cursor: 'pointer',
              padding: 0,
              font: 'inherit',
            }}
          >
            Tout désélectionner
          </button>
        )}
      </$BulkActionCounter>
      <$BulkActionButton
        type={BUTTON_TYPES.BUTTON}
        primary
        onClick={onClick}
        isLoading={isLoading}
      >
        {buttonMessage.defaultMessage}
      </$BulkActionButton>
    </$BulkActionContainer>
  );
};

export default BulkAction;
